<template>
  <b-form-group :label="label"
                :invalid-feedback="errorTxt"
                :state="state">
    <b-form-file
      v-model="inputVal"
      :accept="accept"
      :state="state"
      :placeholder="placeholder"
      @input="change"
      multiple>
    </b-form-file>
  </b-form-group>
</template>

<script>
export default {
  props: {
    service: String,
    model: Object,
    attribute: String,
    attributeFileName: String,
    attributeFileType: String,
    label: String,
    placeholder: String,
    errors: Array,
    accept: String,
    maxSize: {
      type: Number,
      default: 10
    },
    errorOnly: Boolean
  },
  data() {
    return {
      inputVal: null,
      state: null,
      errorTxt: ''
    }
  },
  methods: {
    async change() {
      this.state = null
      this.errorTxt = null
      if (this.inputVal) {
        let filesData = []
        let hasError = false
        for (let file of this.inputVal) {
          if (this.accept && !this.accept.split(',').includes(file.type)) {
            this.state = false
            hasError = true
            this.errorTxt = this.$t('invalidType')
            break
          } else if (file.size / (1024 * 1024) > this.maxSize) {
            this.state = false
            hasError = true
            this.errorTxt = this.$t('maxSizeExceeded')
            break
          } else {
            filesData.push(file)
          }
        }

        if (!hasError) {
          let loader = this.$loading.show()
          const formData = new FormData()
          filesData.forEach(file => {
            formData.append('file', file)
          })
          try {
            let response = await this.$service.post(this.service, formData)
            this.model[this.attribute] = response.data
            this.$emit('change')
          } catch (error) {
            this.state = false
            this.errorTxt = error.message
          } finally {
            loader.hide()
          }
        }
      }
    }
  },
  watch: {
    errors(val) {
      let hasErr = false
      if (val.length) {
        val.forEach(v => {
          if (v.param === this.attribute) {
            this.state = false
            this.errorTxt = v.msg
            hasErr = true
          }
        })
      }
      if (!this.errorOnly) {
        this.state = !hasErr
      }
    }
  },
  i18n: {
    messages: {
      vi: {
        invalidType: 'Loại tập tin không hợp lệ',
        maxSizeExceeded: 'Vượt quá kích thước tệp tối đa'
      },
      en: {
        invalidType: 'Invalid file type',
        maxSizeExceeded: 'Max file size exceeded'
      }
    }
  }
}
</script>